module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopup.remove),
      expression: "showPopup.remove"
    }],
    staticClass: "sweet-alert showSweetAlert visible",
    staticStyle: {
      "border": "1px dashed gray",
      "display": "block"
    },
    attrs: {
      "data-allow-outside-click": "false",
      "data-animation": "pop"
    }
  }, [_c('div', {
    staticClass: "sa-icon sa-info",
    staticStyle: {
      "display": "block"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Confirmation")]), _vm._v(" "), (_vm.preconizationToRemove) ? _c('p', {
    staticClass: "lead text-muted text-left"
  }, [_vm._v("\n      Etes-vous sûr de vouloir supprimer la préconisation d'action « " + _vm._s(_vm.preconizationToRemove.name) + " » ?\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sa-button-container"
  }, [_c('button', {
    staticClass: "cancel btn btn-lg btn-default btn-danger",
    on: {
      "click": function($event) {
        _vm.showPopup.remove = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "sa-confirm-button-container"
  }, [_c('button', {
    staticClass: "confirm btn btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.removePreconizationAction(_vm.preconizationToRemove.id)
      }
    }
  }, [_vm._v("Oui")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopup.actions),
      expression: "showPopup.actions"
    }],
    staticClass: "sweet-alert showSweetAlert visible popup_actions",
    staticStyle: {
      "border": "1px dashed gray",
      "display": "block"
    },
    attrs: {
      "data-allow-outside-click": "false",
      "data-animation": "pop"
    }
  }, [_c('h2', [_vm._v("Détail des actions de la préconisation "), (_vm.preconizationToShow) ? _c('span', [_vm._v(_vm._s(_vm.preconizationToShow.title))]) : _vm._e()]), _vm._v(" "), (_vm.preconizationToShow) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 mt-30 mb-30"
  }, [_vm._v("\n        " + _vm._s(_vm.preconizationToShow.columns.length) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sa-button-container"
  }, [_c('div', {
    staticClass: "sa-confirm-button-container"
  }, [_c('button', {
    staticClass: "confirm btn btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.showPopup.actions = false;
        _vm.preconizationToShow = null
      }
    }
  }, [_vm._v("Ok")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 mt-30 mb-30"
  }, [_c('list', {
    attrs: {
      "columns": _vm.columns,
      "dataSet": _vm.dataSet
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-circle green mt-20",
    attrs: {
      "to": {
        name: 'quizzes_preconizations_create_action'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n       Nouvelle préconisation\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-circle yellow mt-20",
    attrs: {
      "to": {
        name: 'quizzes_preconizations_show_actions',
        params: {
          slug: _vm.$route.params.slug
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v("\n       Voir en détail\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1933eed9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/quizzes/preconizations/list.vue
// module id = 104
// module chunks = 0